const getLangValue = (list, lang) => {
    const translation = list.find((item) =>  item.lang === lang);
    return translation ? translation.value : '';
};

export default getLangValue;
